import axios from "axios";
import Swal from 'sweetalert2';

// ---------------------------
// App Config
// ---------------------------
const userName = localStorage.getItem('username');
const ipAddress = window.location.hostname;
const baseUrl = 'https://ecart.mgmebuild.com/api/';
const baseimgUrl = 'https://ecart.mgmebuild.com/';

// ---------------------------
// Date Formatter
// ---------------------------
const formatDateTime = (dateTimeStr) => {
  const date = new Date(dateTimeStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// ---------------------------
// Axios Interceptors
// ---------------------------
axios.interceptors.request.use(
  config => {
    const tokens = localStorage.getItem('authTokens');
    let token = tokens ? JSON.parse(tokens).access : null;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    const errorResponse = error.response;
    if (errorResponse) {
      const status = errorResponse.status;
      const message =
        status === 401 ? 'Unauthorized' :
        status === 403 ? 'Permission Denied' :
        status === 500 ? 'Internal Server Error' :
        'An error occurred';
      Swal.fire({ title: `Error ${status}`, text: message, icon: 'error', button: 'OK' });
    }
    return Promise.reject(error);
  }
);

export { baseUrl, userName, ipAddress, baseimgUrl, formatDateTime};
export default axios;
